import React from 'react';
import Icon from './Icon';

/* Figma: Modal close button
 * variant='default' : muted icon with hover (일반 모달)
 * variant='overlay'  : dark circle with white X (풀스크린/오버레이 모달)
 */
const sizeMap = {
  sm: 24,
  md: 32,
};

export default function ModalCloseButton({ onClick, size = 'md', variant = 'default', className = '' }) {
  if (variant === 'overlay') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`w-10 h-10 bg-mono-900 rounded-full flex items-center justify-center text-white hover:bg-mono-800 transition-colors ${className}`}
      >
        <Icon name="close" size={18} />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-mono-400 hover:text-mono-900 transition ${className}`}
    >
      <Icon name="close" size={sizeMap[size] || sizeMap.md} />
    </button>
  );
}
